<template>
  <section id="top_5_sport_venue_revenue" v-if="items">
    <b-card no-body>
      <b-card-header>
        <b-card-title>{{ $t('dashboard.serviceRevenue') }}</b-card-title>
      </b-card-header>

      <!-- chart -->
      <b-card-body>
        <div v-if="!loading">
          <chartjs-component-bar-chart
            :height="400"
            :data="data"
            :options="options"
          />
        </div>
        <div
          class="d-flex justify-content-center align-items-center mb-1"
          v-else
        >
          <b-spinner label="loading" type="grow" />
        </div>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BSpinner,
} from 'bootstrap-vue'
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'
import Repository from '@/repositories/RepositoryFactory'

const DashboardRepository = Repository.get('dashboard')

const chartColors = {
  primaryColorShade: '#836AF9',
  yellowColor: '#ffe800',
  successColorShade: '#28dac6',
  warningColorShade: '#ffe802',
  warningLightColor: '#FDAC34',
  infoColorShade: '#299AFF',
  greyColor: '#4F5D70',
  blueColor: '#2c9aff',
  blueLightColor: '#84D0FF',
  greyLightColor: '#EDF1F4',
  tooltipShadow: 'rgba(0, 0, 0, 0.25)',
  lineChartPrimary: '#666ee8',
  lineChartDanger: '#ff4961',
  labelColor: '#6e6b7b',
  grid_line_color: 'rgba(200, 200, 200, 0.2)',
}
export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    ChartjsComponentBarChart,
    BSpinner,
  },
  data() {
    return {
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: chartColors.successColorShade,
            borderColor: 'transparent',
          },
        ],
      },
      options: {
        elements: {
          rectangle: {
            borderWidth: 2,
            borderSkipped: 'bottom',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        legend: {
          display: false,
        },
        tooltips: {
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: chartColors.tooltipShadow,
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: true,
                color: chartColors.grid_line_color,
                zeroLineColor: chartColors.grid_line_color,
              },
              scaleLabel: {
                display: false,
              },
              ticks: {
                fontColor: chartColors.labelColor,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: chartColors.grid_line_color,
                zeroLineColor: chartColors.grid_line_color,
              },
              ticks: {
                stepSize: 100,
                min: 0,
                max: 400,
                fontColor: chartColors.labelColor,
              },
            },
          ],
        },
      },
      loading: false,
      items: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      DashboardRepository.index()
        .then((response) => {
          this.data.labels = response.data.data.map((item) => item.name)
          this.data.datasets[0].data = response.data.data.map(
            (item) => item.total
          )
          this.items = response.data.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
